import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/appointments/$appointmentId/')({
  loader: ({ params: { appointmentId } }) => {
    redirect({ to: '/appointments', search: { appointmentId }, throw: true });
  },
});
